<template>
  <div class="etx-container Container" :class="paragraphClassList">
    <div class="BigPicture">
      <div class="BigPicture__filter">
        <div v-for="tab in tabs" class="BigPicture__filter__item" 
          :data-bigpicture-filter="tab?.filters?.join(',')"
          :key="tab?.uuid"
        >
          <span>{{ tab?.title }}</span>
        </div>
      </div>

      <div class="BigPicture__map" v-if="!isEditing">
        <div class="BigPicture__map__background">
          <img src="./layers/equans_bigpicture_layer_1.svg">
          <img src="./layers/equans_bigpicture_layer_2_energy.svg" data-bigpicture-filter="energy">
          <img src="./layers/equans_bigpicture_layer_3_kuma.svg" data-bigpicture-filter="kuma">
          <img src="./layers/equans_bigpicture_layer_4_infra.svg" data-bigpicture-filter="infra">
          <img src="./layers/equans_bigpicture_layer_5_buildings.svg" data-bigpicture-filter="buildings">
          <img src="./layers/equans_bigpicture_layer_6.svg">
          <img src="./layers/equans_bigpicture_layer_7_energy.svg" data-bigpicture-filter="energy">
          <img src="./layers/equans_bigpicture_layer_8_infra.svg" data-bigpicture-filter="infra">
          <img src="./layers/equans_bigpicture_layer_9.svg">
          <img src="./layers/equans_bigpicture_layer_10_kuma.svg" data-bigpicture-filter="kuma">
          <img src="./layers/equans_bigpicture_layer_11_infra-kuma.svg" data-bigpicture-filter="infra,kuma">
        </div>

        <div class="BigPicture__map__markers">

          <div v-for="highlight in highlights" class="BigPictureMarker" 
            :data-overlay-align="highlight?.alignment"
            :data-bigpicture-filter="highlight?.filters?.join(',')" 
            :data-bigpicture-id="highlight?.identifier"
            :key="highlight?.uuid"
          >

            <div class="BigPictureMarker__dot">
              <i class="fal fa-plus"></i>
              <i class="fal fa-minus"></i>
            </div>

            <div class="BigPictureMarker__overlay">

              <div class="etx-text Text">
                <p class="font-size-large font-weight-bold">{{ highlight?.title }}</p>
                <p class="font-size-small">{{ highlight?.description?.replace(/\n/g, '<br>') }}</p>
              </div>

              <div class="etx-button-list ButtonList">

                <a class="etx-button Button minimal" 
                  :href="highlight?.buttonLink?.uri?.path"
                  :title="highlight?.buttonAlt"
                >
                  <div class="etx-button__text Button__text">
                    <span>{{ highlight?.buttonLabel }}</span>
                  </div>
                  <div class="etx-button__icon Button__icon">
                    <i class="far fa-long-arrow-right"></i>
                  </div>
                </a>

              </div>

            </div>

          </div>

        </div>
      </div>

      <div class="BigPicture__controls">
        <div class="BigPicture__controls__zoom">
          <div class="BigPicture__controls__zoom__in">
            <i class="far fa-plus"></i>
          </div>
          <div class="BigPicture__controls__zoom__out">
            <i class="far fa-minus"></i>
          </div>
        </div>

        <div class="BigPicture__controls__pan">
          <div class="BigPicture__controls__pan__left">
            <i class="far fa-arrow-left"></i>
          </div>
          <div class="BigPicture__controls__pan__right">
            <i class="far fa-arrow-right"></i>
          </div>
          <div class="BigPicture__controls__pan__top">
            <i class="far fa-arrow-up"></i>
          </div>
          <div class="BigPicture__controls__pan__bottom">
            <i class="far fa-arrow-down"></i>
          </div>
        </div>
      </div>    

    </div>

  </div>
</template>

<script lang="ts" setup>

import { onMounted } from 'vue';
import type { ParagraphBigPictureFragment } from '#graphql-operations'

const props = defineProps<ParagraphBigPictureFragment>()

const { options, isEditing } = defineBlokkli({
  bundle: 'big_picture',
  globalOptions: ['spacingTop', 'spacingBottom'],
})

const paragraphClassList = computed(() => {

  const classList = []

  if (options.value.spacingTop) {
    classList.push(options.value.spacingTop)
  }

  if (options.value.spacingBottom) {
    classList.push(options.value.spacingBottom)
  }

  return classList
})


</script>